import { render, staticRenderFns } from "./FolderSelector.vue?vue&type=template&id=f50bdf7a"
import script from "./FolderSelector.vue?vue&type=script&lang=tsx"
export * from "./FolderSelector.vue?vue&type=script&lang=tsx"
import style0 from "./FolderSelector.vue?vue&type=style&index=0&id=f50bdf7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports